import React from "react";
import "./MenuGrid.css";

const MenuGrid = () => {
  const launchButtons = [
    {
      src: "images/piperears-logo-512.webp",
      title: "Piper Ears",
      subtitle: "Ear Training",
      alt: "Button launch piper ears",
      id: "http://piper-ears.web.app"
    },
    {
      src: "images/piperkeys-logo-512.webp",
      title: "Piper Keys",
      subtitle: "Key Signatures and Modes",
      alt: "Button launch piper keys",
      id: "http://piper-keys.web.app"
    }
  ];

  // On image click load a new tab with the id url
  const handleImageClick = (id: string) => {
    window.open(id); // Opens in a new tab
  };

  return (
    <div className="menu-grid">
      {launchButtons.map((img) => (
        <button
          key={img.id}
          className="image-button"
          onClick={() => handleImageClick(img.id)}
        >
          <img src={img.src} alt={img.alt} />
          <h3>{img.title}</h3>
          <p>{img.subtitle}</p>
        </button>
      ))}
    </div>
  );
};

export default MenuGrid;
